export interface IRccap {
    id: number,
    failDate: string,
    recipientAlias: string,
    donorAlias: string,
    whatHappened: string
}